import { GoogleOAuthProvider } from '@react-oauth/google';
import { RouterProvider } from 'react-router';
import { ToastProvider } from './components/ui/toast';
import { env } from './lib/env';
import { AuthProvider } from './providers/AuthProvider';
import { QueryClientProvider } from './providers/QueryClientProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { router } from './routes';

export function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider>
        <AuthProvider>
          <ToastProvider>
            <GoogleOAuthProvider clientId={env.googleClientId}>
              <RouterProvider router={router} />
            </GoogleOAuthProvider>
          </ToastProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
